import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { baseUrlApi } from '../../utils/url';

export interface ScheduledSend {
  id: number;
  OwnerId: number;
  LeaseId: number;
  typeenvoi: string;
  dayOfMonth: number;
  enabled: boolean;
  name: string;
  lastSentMonth: string | null;
  createdAt: string;
  lease?: { id: number; [key: string]: any };
}

const getHeaders = () => {
  const raw = localStorage.getItem('user');
  const token = raw ? JSON.parse(raw).token : '';
  return { Authorization: `bearer ${token}` };
};

export const fetchScheduledSends = createAsyncThunk(
  'scheduledSend/fetchByOwner',
  async (ownerId: number) => {
    const res = await axios.get(`${baseUrlApi}/scheduledsends/owner/${ownerId}`, { headers: getHeaders() });
    return res.data as ScheduledSend[];
  }
);

export const bulkCreateScheduledSends = createAsyncThunk(
  'scheduledSend/bulkCreate',
  async (items: Omit<ScheduledSend, 'id' | 'createdAt' | 'lastSentMonth' | 'lease'>[]) => {
    const res = await axios.post(`${baseUrlApi}/scheduledsends/bulk`, { items }, { headers: getHeaders() });
    return res.data as ScheduledSend[];
  }
);

export const toggleScheduledSend = createAsyncThunk(
  'scheduledSend/toggle',
  async ({ id, enabled }: { id: number; enabled: boolean }) => {
    const res = await axios.put(`${baseUrlApi}/scheduledsends/${id}`, { enabled }, { headers: getHeaders() });
    return res.data as ScheduledSend;
  }
);

export const deleteScheduledSend = createAsyncThunk(
  'scheduledSend/delete',
  async (id: number) => {
    await axios.delete(`${baseUrlApi}/scheduledsends/${id}`, { headers: getHeaders() });
    return id;
  }
);

const scheduledSendSlice = createSlice({
  name: 'scheduledSend',
  initialState: {
    sends: [] as ScheduledSend[],
    loading: false,
    error: null as string | null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchScheduledSends.pending,   (s) => { s.loading = true; })
      .addCase(fetchScheduledSends.fulfilled, (s, a) => { s.loading = false; s.sends = a.payload; })
      .addCase(fetchScheduledSends.rejected,  (s, a) => { s.loading = false; s.error = a.error.message ?? null; })

      .addCase(bulkCreateScheduledSends.fulfilled, (s, a) => { s.sends.push(...a.payload); })

      .addCase(toggleScheduledSend.fulfilled, (s, a) => {
        const idx = s.sends.findIndex(x => x.id === a.payload.id);
        if (idx !== -1) s.sends[idx] = a.payload;
      })

      .addCase(deleteScheduledSend.fulfilled, (s, a) => {
        s.sends = s.sends.filter(x => x.id !== a.payload);
      });
  },
});

export default scheduledSendSlice.reducer;
